const ListItemButton = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      if (ownerState?.selected) {
        return {
          backgroundColor: `var(--palette-primary_button) !important`,
          color: "var(--palette-primary_button_text)!important",
          borderRadius: "5px",
        };
      }
      return {
        // color: "var(--palette-primary_button_text)!important",
        "&:hover": {
          backgroundColor: `var(--palette-secondary_button_hover) !important`,
          color: "var(--palette-secondary_button_text)!important",
        },
      };
    },
  },
};

export default ListItemButton;
